// Generated by purs version 0.13.8
"use strict";
var $foreign = require("./foreign.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Error_Class = require("../Control.Monad.Error.Class/index.js");
var Control_Monad_Free = require("../Control.Monad.Free/index.js");
var Control_Monad_Maybe_Trans = require("../Control.Monad.Maybe.Trans/index.js");
var Control_Monad_Reader_Trans = require("../Control.Monad.Reader.Trans/index.js");
var Control_Monad_Rec_Class = require("../Control.Monad.Rec.Class/index.js");
var Control_Monad_Trans_Class = require("../Control.Monad.Trans.Class/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Effect = require("../Effect/index.js");
var Effect_Aff = require("../Effect.Aff/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Effect_Exception = require("../Effect.Exception/index.js");
var Effect_Ref = require("../Effect.Ref/index.js");
var Framework_Render_Color = require("../Framework.Render.Color/index.js");
var Framework_Render_Core = require("../Framework.Render.Core/index.js");
var Graphics_Canvas = require("../Graphics.Canvas/index.js");
var runRenderCanvas = function (vars) {
    return function (f) {
        var go = function (v) {
            return function (v1) {
                if (v instanceof Framework_Render_Core.LoadImage) {
                    return function __do() {
                        var images = Effect_Class.liftEffect(Effect_Class.monadEffectEffect)(Effect_Ref.read(v1.imageData.index))();
                        var img = Data_Map_Internal.lookup(Data_Ord.ordString)(v.value0)(images);
                        return v.value1(img);
                    };
                };
                if (v instanceof Framework_Render_Core.GetDimensions) {
                    return function __do() {
                        var width = Graphics_Canvas.getCanvasWidth(v1.canvas)();
                        var height = Graphics_Canvas.getCanvasHeight(v1.canvas)();
                        return v.value0({
                            width: width,
                            height: height
                        });
                    };
                };
                if (v instanceof Framework_Render_Core.FillRect) {
                    return function __do() {
                        var ctx = Graphics_Canvas.getContext2D(v1.canvas)();
                        Graphics_Canvas.withContext(ctx)(function __do() {
                            Graphics_Canvas.setFillStyle(ctx)(v.value0)();
                            return Graphics_Canvas.fillRect(ctx)(v.value1)();
                        })();
                        return v.value2;
                    };
                };
                if (v instanceof Framework_Render_Core.DrawLine) {
                    return function __do() {
                        var ctx = Graphics_Canvas.getContext2D(v1.canvas)();
                        Graphics_Canvas.withContext(ctx)(function __do() {
                            Graphics_Canvas.beginPath(ctx)();
                            Graphics_Canvas.setStrokeStyle(ctx)(Data_Newtype.un(Framework_Render_Color.newtypeColor)(Framework_Render_Color.Color)(v.value0.color))();
                            Graphics_Canvas.setLineWidth(ctx)(v.value0.width)();
                            Graphics_Canvas.moveTo(ctx)(v.value0.start.x)(v.value0.start.y)();
                            Graphics_Canvas.lineTo(ctx)(v.value0.end.x)(v.value0.end.y)();
                            return Graphics_Canvas.stroke(ctx)();
                        })();
                        return v.value1;
                    };
                };
                if (v instanceof Framework_Render_Core.DrawImage) {
                    return function __do() {
                        var images = Effect_Ref.read(v1.imageData.array)();
                        var ctx = Graphics_Canvas.getContext2D(v1.canvas)();
                        (function () {
                            var v2 = Data_Array.index(images)(v.value0);
                            if (v2 instanceof Data_Maybe.Nothing) {
                                return Control_Monad_Error_Class.throwError(Control_Monad_Error_Class.monadThrowEffect)(Effect_Exception.error("Missing image!"))();
                            };
                            if (v2 instanceof Data_Maybe.Just) {
                                return Graphics_Canvas.drawImageScale(ctx)(v2.value0)(v.value1.x)(v.value1.y)(v.value1.width)(v.value1.height)();
                            };
                            throw new Error("Failed pattern match at Framework.Render.Canvas (line 114, column 6 - line 116, column 69): " + [ v2.constructor.name ]);
                        })();
                        return v.value2;
                    };
                };
                if (v instanceof Framework_Render_Core.DrawImageFull) {
                    return function __do() {
                        var images = Effect_Ref.read(v1.imageData.array)();
                        var ctx = Graphics_Canvas.getContext2D(v1.canvas)();
                        (function () {
                            var v2 = Data_Array.index(images)(v.value0);
                            if (v2 instanceof Data_Maybe.Nothing) {
                                return Control_Monad_Error_Class.throwError(Control_Monad_Error_Class.monadThrowEffect)(Effect_Exception.error("Missing image!"))();
                            };
                            if (v2 instanceof Data_Maybe.Just) {
                                return Graphics_Canvas.drawImageFull(ctx)(v2.value0)(v.value1.x)(v.value1.y)(v.value1.width)(v.value1.height)(v.value2.x)(v.value2.y)(v.value2.width)(v.value2.height)();
                            };
                            throw new Error("Failed pattern match at Framework.Render.Canvas (line 123, column 6 - line 127, column 37): " + [ v2.constructor.name ]);
                        })();
                        return v.value3;
                    };
                };
                throw new Error("Failed pattern match at Framework.Render.Canvas (line 82, column 3 - line 82, column 58): " + [ v.constructor.name, v1.constructor.name ]);
            };
        };
        return Control_Monad_Reader_Trans.runReaderT(Control_Monad_Free.runFreeM(Framework_Render_Core.renderF)(Control_Monad_Reader_Trans.monadRecReaderT(Control_Monad_Rec_Class.monadRecEffect))(function ($56) {
            return Control_Monad_Reader_Trans.ReaderT(go($56));
        })(f))(vars);
    };
};
var fetchImage = function (path) {
    return function (v) {
        return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(v.index)))(function (images) {
            var v1 = Data_Map_Internal.lookup(Data_Ord.ordString)(path)(images);
            if (v1 instanceof Data_Maybe.Just) {
                return Control_Applicative.pure(Effect_Aff.applicativeAff)(Data_Unit.unit);
            };
            if (v1 instanceof Data_Maybe.Nothing) {
                return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Aff.makeAff(function (h) {
                    return function __do() {
                        Graphics_Canvas.tryLoadImage(path)((function () {
                            var $57 = Data_Maybe.maybe(Data_Either.Left.create(Effect_Exception.error("failed to load image " + path)))(Control_Applicative.pure(Data_Either.applicativeEither));
                            return function ($58) {
                                return h($57($58));
                            };
                        })())();
                        return Data_Monoid.mempty(Effect.monoidEffect(Effect_Aff.monoidCanceler))();
                    };
                }))(function (imgsrc) {
                    return Data_Functor["void"](Effect_Aff.functorAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(function __do() {
                        var nextIndex = Data_Functor.map(Effect.functorEffect)(Data_Array.length)(Effect_Ref.read(v.array))();
                        Effect_Ref.write(Data_Map_Internal.insert(Data_Ord.ordString)(path)(nextIndex)(images))(v.index)();
                        return Effect_Ref.modify(Data_Function.flip(Data_Array.snoc)(imgsrc))(v.array)();
                    }));
                });
            };
            throw new Error("Failed pattern match at Framework.Render.Canvas (line 64, column 3 - line 73, column 54): " + [ v1.constructor.name ]);
        });
    };
};
var init = function (v) {
    return Control_Monad_Maybe_Trans.runMaybeT(Control_Bind.bind(Control_Monad_Maybe_Trans.bindMaybeT(Effect_Aff.monadAff))(Control_Monad_Maybe_Trans.MaybeT(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Graphics_Canvas.getCanvasElementById(v.canvasId))))(function (canvas) {
        return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Maybe_Trans.bindMaybeT(Effect_Aff.monadAff))(Effect_Class.liftEffect(Control_Monad_Maybe_Trans.monadEffectMaybe(Effect_Aff.monadEffectAff))(Graphics_Canvas.setCanvasDimensions(canvas)({
            width: v.width,
            height: v.height
        })))(function () {
            return Control_Bind.bind(Control_Monad_Maybe_Trans.bindMaybeT(Effect_Aff.monadAff))(Effect_Class.liftEffect(Control_Monad_Maybe_Trans.monadEffectMaybe(Effect_Aff.monadEffectAff))(Graphics_Canvas.getContext2D(canvas)))(function (context) {
                return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Maybe_Trans.bindMaybeT(Effect_Aff.monadAff))(Effect_Class.liftEffect(Control_Monad_Maybe_Trans.monadEffectMaybe(Effect_Aff.monadEffectAff))($foreign.setImageSmoothing(context)(false)))(function () {
                    return Control_Bind.bind(Control_Monad_Maybe_Trans.bindMaybeT(Effect_Aff.monadAff))(Effect_Class.liftEffect(Control_Monad_Maybe_Trans.monadEffectMaybe(Effect_Aff.monadEffectAff))(Effect_Ref["new"](Data_Map_Internal.empty)))(function (index) {
                        return Control_Bind.bind(Control_Monad_Maybe_Trans.bindMaybeT(Effect_Aff.monadAff))(Effect_Class.liftEffect(Control_Monad_Maybe_Trans.monadEffectMaybe(Effect_Aff.monadEffectAff))(Effect_Ref["new"](Data_Monoid.mempty(Data_Monoid.monoidArray))))(function (array) {
                            var imageData = {
                                index: index,
                                array: array
                            };
                            return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Maybe_Trans.bindMaybeT(Effect_Aff.monadAff))(Control_Monad_Trans_Class.lift(Control_Monad_Maybe_Trans.monadTransMaybeT)(Effect_Aff.monadAff)(Data_Foldable.for_(Effect_Aff.applicativeAff)(Data_Foldable.foldableArray)(v.imagePaths)(function (p) {
                                return fetchImage(p)(imageData);
                            })))(function () {
                                return Control_Applicative.pure(Control_Monad_Maybe_Trans.applicativeMaybeT(Effect_Aff.monadAff))({
                                    canvas: canvas,
                                    imageData: imageData
                                });
                            });
                        });
                    });
                });
            });
        });
    }));
};
module.exports = {
    runRenderCanvas: runRenderCanvas,
    init: init
};
